import { License } from '@yfiles/yfiles'

import licenseData from '../license.json'

License.value = licenseData
